import { colors } from '@mui/material';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import "@mui/material/styles";

/***Colors***/

const primaryTextColor = "#777777";
const secondaryTextColor = "#E5E5EB";
const primaryMainColor = "#AF0000";
const primaryLightColor = "#87c5e2";

/***Sizes***/
const borderRadius = 4;
declare module "@mui/material/styles" {
    interface Palette {
        customYellow: Palette["primary"];
    }

    interface PaletteOptions {
        customYellow?: PaletteOptions["primary"];
    }
}
const theme = createTheme({

    breakpoints: {
        keys: ['xs', 'sm', 'md', 'lg', 'xl'],
        values: {
            xs: 0,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 1600
        }
    },
    palette: {

        primary: {
            main: primaryMainColor,
            light: primaryLightColor,
        },
        secondary: {
            main: primaryTextColor,
            light: secondaryTextColor
        },
        customYellow: {
            main: "#FFD700",
            light: "#FFEA70",
            dark: "#C7A300",
            contrastText: "#000000",
        },
    },

    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
    },
});

const nextBetTheme = createTheme({
    palette: {
        primary: {
            main: '#003c79',
        },
        secondary: {
            main: '#ffe000',
            light: "#ffe000"
        },
        customYellow: {
            main: '#ffe000',
        }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.restartSession": {
                        "&:hover": {
                            color: "#003c79"
                        }
                    }
                }
            }
        }
    }
});

const zedBetTheme = createTheme({
    palette: {
        primary: {
            main: '#211e25',
        },
        secondary: {
            main: '#ffe000',
            light: "#ffe000"
        },
        customYellow: {
            main: '#ffe000',
        }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.restartSession": {
                        "&:hover": {
                            color: "#003c79"
                        }
                    }
                }
            }
        }
    }
});

const fTVTheme = createTheme({
    palette: {
        primary: {
            main: '#211e25',
        },
        secondary: {
            main: '#DCB567',
            light: "#DCB567"
        },
        customYellow: {
            main: '#DCB567',
            light: '#E9DB5D',
            dark: '#A29415',
            contrastText: '#242105',
        }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.restartSession": {
                        "&:hover": {
                            color: "#003c79"
                        }
                    }
                }
            }
        }
    }
});

const jamboreeTheme = createTheme({
    palette: {
        primary: {
            main: '#186433',
        },
        secondary: {
            main: '#ffe000',
            light: "#ffe000"
        },
        customYellow: {
            main: '#ffe000',
            light: '#E9DB5D',
            dark: '#A29415',
            contrastText: '#242105',
        }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.restartSession": {
                        "&:hover": {
                            color: "#003c79"
                        }
                    }
                }
            }
        }
    }
});

const babyTheme = createTheme({
    palette: {
        primary: {
            main: '#7b1eda',
        },
        secondary: {
            main: '#ffe000',
            light: "#ffe000"
        },
        customYellow: {
            main: '#ffe000',
            light: '#E9DB5D',
            dark: '#A29415',
            contrastText: '#242105',
        }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.restartSession": {
                        "&:hover": {
                            color: "#003c79"
                        }
                    }
                }
            }
        }
    }
});

const zipangTheme = createTheme({
    palette: {
        primary: {
            main: '#fff',
        },
        secondary: {
            main: '#ffe000',
            light: "#DCB567"
        },
        customYellow: {
            main: '#ffe000',
            light: '#E9DB5D',
            dark: '#A29415',
            contrastText: '#242105',
        }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.restartSession": {
                        "&:hover": {
                            color: "#003c79"
                        }
                    }
                }
            }
        }
    }
});

 const spinmileTheme = createTheme({
    palette: {
        primary: {
            main: '#F8FAFB',
        },
        secondary: {
            main: '#200D3F',
            light: "#200D3F"
        },
        customYellow: {
            main: '#200D3F',

        }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2: {
            textAlign: "center",
            fontSize: "35px",
            color: primaryTextColor,
            fontWeight: "bold"
        },
        h5: {
            fontSize: 24,
        },
        subtitle2: {
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {

        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto',
                    // '&.Mui-focused': {
                    //     borderColor: '#200D3F',
                    // },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#200D3F !important',
                    },
                },
            },
        },

        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 3
                }
            },
        },
        MuiButton: {
            styleOverrides: {

                root: {
                    color: '#B8BBB9 !important',
                    '& svg': {
                        color: '#200D3F',
                    },
                    "&.restartSession": {
                        "&:hover": {
                            color: "#200D3F"
                        }
                    }
                }
            }
        }
    },
   
});
 
const mswTheme = createTheme({
   palette: {
      primary: {
        main: '#343434', 
      },
      secondary: {
        main: '#eb6123',
        light:"#eb6123" 
      },
      customYellow: {
        main: '#eb6123',
      }
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2:{
            textAlign:"center",
            fontSize:"35px",
            color:primaryTextColor,
            fontWeight:"bold"
        },
        h5:{
            fontSize: 24,
        },
        subtitle2:{
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {
     
        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
               tooltip:{
                borderRadius:3
               }
            },
        },
           MuiButton: {
            styleOverrides: {

                root: {
                    color: '#fff !important',
                    '& svg': {
                        color: '#fff',
                    },
                    "&.restartSession": {
                        "&:hover": {
                            color: "#fff"
                        }
                    }
                }
            }
        },
      MuiDialogActions: {
  styleOverrides: {
    root: {
      '& .MuiButton-root': {
        color: '#343434 !important',
      },
    },
  },
},

    }
});
  export const defaultTheme = responsiveFontSizes(theme);
  export const nextBetThemeWithFonts = responsiveFontSizes(nextBetTheme);
  export const zedBetThemeWithFonts = responsiveFontSizes(zedBetTheme);
  export const fTVThemeWithFonts = responsiveFontSizes(fTVTheme);
  export const jamboreeThemeWithFonts = responsiveFontSizes(jamboreeTheme);
  export const babyThemeWithFonts = responsiveFontSizes(babyTheme);
  export const zipangThemeWithFonts = responsiveFontSizes(zipangTheme);
  export const spinmileThemeWithFonts = responsiveFontSizes(spinmileTheme);
  export const mswThemeWithFonts = responsiveFontSizes(mswTheme);